import { motion } from "framer-motion";
import { ScrambleText } from "./ScrambleText";

export const ease = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal. Pass an array of strings (lines).
export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className={`block ${lineClass}`}
          initial={{ y: "110%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 0.95, ease, delay: delay + i * 0.11 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const SectionLabel = ({ index, children, className = "" }) => (
  <div className={`flex items-center gap-3 text-[#BACD1C] ${className}`} data-testid="section-label">
    <span className="font-mono text-xs tracking-[0.3em] uppercase">
      {index && <span className="text-white/40">[{index}]</span>}{" "}
      <ScrambleText text={children} />
    </span>
    <span className="h-px flex-1 bg-white/10" />
  </div>
);
